import { app } from 'core';
import { useDispatch } from 'react-redux';
import type { MouseEvent } from 'react';

export const useHandleTrackClick = () => {
  const dispatch = useDispatch();

  const handleTrackClick = (event: MouseEvent<HTMLElement> | UIEvent, isSubmenu = false) => {
    const eventLabel = (event.currentTarget as HTMLButtonElement)?.getAttribute('data-event') || '';
    dispatch(app.actions.trackMenuClick({ label: eventLabel, isSubmenu }));
  };

  return {
    handleTrackClick,
  };
};
